import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import { LANDINGS } from "./data/landings.ts";
import CookieBanner from "./components/legal/CookieBanner.tsx";
import WhatsAppFloating from "./components/WhatsAppButton.tsx";

// Lazy-load todo lo que NO es la home para mantener el bundle inicial pequeño.
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const AvisoLegal = lazy(() => import("./pages/legal/AvisoLegal.tsx"));
const Privacidad = lazy(() => import("./pages/legal/Privacidad.tsx"));
const Cookies = lazy(() => import("./pages/legal/Cookies.tsx"));
const Terminos = lazy(() => import("./pages/legal/Terminos.tsx"));
const LandingPage = lazy(() => import("./pages/landings/LandingPage.tsx"));
const BlogIndex = lazy(() => import("./pages/blog/BlogIndex.tsx"));
const BlogPost = lazy(() => import("./pages/blog/BlogPost.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/legal/aviso-legal" element={<AvisoLegal />} />
          <Route path="/legal/privacidad" element={<Privacidad />} />
          <Route path="/legal/cookies" element={<Cookies />} />
          <Route path="/legal/terminos" element={<Terminos />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          {/*
            Rutas de landings declaradas explícitamente para que escáneres SEO
            estáticos (que no resuelven LANDINGS.map) las detecten como endpoints.
            La fuente de verdad sigue siendo src/data/landings.ts; mantener ambos en sync.
          */}
          <Route path="/google-maps-restaurantes" element={<LandingPage />} />
          <Route path="/google-maps-clinicas" element={<LandingPage />} />
          <Route path="/google-maps-hoteles" element={<LandingPage />} />
          <Route path="/google-maps-inmobiliarias" element={<LandingPage />} />
          <Route path="/google-maps-talleres" element={<LandingPage />} />
          <Route path="/google-maps-centros-estetica" element={<LandingPage />} />
          <Route path="/google-maps-sector-lujo" element={<LandingPage />} />
          <Route path="/google-maps-malaga" element={<LandingPage />} />
          <Route path="/google-maps-sevilla" element={<LandingPage />} />
          <Route path="/google-maps-cadiz" element={<LandingPage />} />
          <Route path="/google-maps-valladolid" element={<LandingPage />} />
          <Route path="/google-maps-granada" element={<LandingPage />} />
          <Route path="/mejorar-posicionamiento-google-maps" element={<LandingPage />} />
          <Route path="/conseguir-resenas-google" element={<LandingPage />} />
          <Route path="/mejorar-resenas-google" element={<LandingPage />} />
          <Route path="/responder-resenas-google" element={<LandingPage />} />
          <Route path="/resenas-negativas-google" element={<LandingPage />} />
          <Route path="/seo-local-google-maps" element={<LandingPage />} />
          <Route path="/agencias-seo-local" element={<LandingPage />} />
          <Route path="/varias-ubicaciones-google-maps" element={<LandingPage />} />
          {/* Fallback: cualquier landing añadida a LANDINGS sin Route explícita arriba. */}
          {LANDINGS.map((l) => (
            <Route key={l.slug} path={`/${l.slug}`} element={<LandingPage />} />
          ))}
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
        <CookieBanner />
        <WhatsAppFloating />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
